import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import StatisticsByCountryCSV from './StatisticsByCountryCSV';
import {
    getData,
    getHeaderName
} from './StatisticsByCountryCSV.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: getData,
    headerName: getHeaderName
});

const StatisticsByCountryCSVComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state)
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByCountryCSV);

export default StatisticsByCountryCSVComponent;
